import React, { ReactElement } from "react";
import { OverlayTrigger, Popover as BootstrapPopover } from "react-bootstrap";
import { FiHelpCircle } from "react-icons/fi";
import Styles from "./Popover.module.scss";

export interface Props {
    buttonClassName?: string;
    title: string;
    children: (ReactElement | string) | (ReactElement | string)[];
    size?: "sm" | "md" | "lg";
    text?: string;
}
export default function Popover({
    buttonClassName, title, children, size, text,
}: Props) {
    const popover = (
        <BootstrapPopover className={Styles[`message-${size}`]}>
            <BootstrapPopover.Header as="h3">{title}</BootstrapPopover.Header>
            <BootstrapPopover.Body>
                {children}
            </BootstrapPopover.Body>
        </BootstrapPopover>
    );
    return (
        <OverlayTrigger
            trigger="click"
            placement="right"
            overlay={popover}
            rootClose
        >
            <button type="button" className={`btn btn-none p-0 ${buttonClassName} align-baseline`}>
                {text || <FiHelpCircle />}
            </button>
        </OverlayTrigger>
    );
}

Popover.defaultProps = {
    buttonClassName: "",
    size: "sm",
    text: undefined,
};
